import { ErrorInputIcon } from '@assets/svgs/ErrorInputIcon'
import { Tooltip } from '@components/shared/Tooltip'
import { InfoIcon } from '@phosphor-icons/react'
import { InputAdornment } from '@mui/material'

import { isNegativeValue } from './helpers/isNegativeValue'

import type { ComponentProps } from './types'

import * as S from './styles'

export const Component = ({
  name,
  label,
  error,
  type = 'text',
  value,
  onChange,
  onBlur,
  required,
  disabled,
  isIcon = true,
  rightIcon,
  maxLength,
  tooltipInfo,
  ...rest
}: ComponentProps) => {
  const isNegative = isNegativeValue(value)

  return (
    <S.FormControl>
      <S.LabelBox disabled={disabled}>
        {label && (
          <S.Label disabled={disabled}>
            {label}
            {required && ' *'}
          </S.Label>
        )}

        {tooltipInfo && (
          <Tooltip width="fit-content" title={tooltipInfo} placement="top">
            <InfoIcon weight="bold" size={16} />
          </Tooltip>
        )}
      </S.LabelBox>

      <S.Input
        id={name}
        name={name}
        variant="outlined"
        autoComplete="off"
        type={type}
        value={value || ''}
        onChange={(e) => onChange?.(e)}
        onBlur={onBlur}
        error={!!error}
        disabled={disabled}
        isNegative={isNegative}
        slotProps={{
          input: {
            endAdornment:
              !!error || !!rightIcon ? (
                <InputAdornment position="end">
                  {!!error && !rightIcon && <ErrorInputIcon />}
                  {!!rightIcon && rightIcon}
                </InputAdornment>
              ) : null
          },
          htmlInput: { maxLength }
        }}
        {...rest}
      />

      {typeof error === 'string' && <S.ErrorMessage>{error}</S.ErrorMessage>}
    </S.FormControl>
  )
}
